
    import './styles.scoped.css';
    export default {
  "step-title": "awsui_step-title_zr0a1_2uwax_5"
};
  